import Imprint from './Imprint';
import Privacy from './Privacy';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="flex flex-col items-center justify-center gap-4 bg-ink-900 px-4 pt-5 pb-14 font-gotham text-brand-light-gray md:flex-row lg:gap-20 lg:text-lg">
      <Imprint />
      <span>Gravity Technologies AG ® {year}</span>
      <Privacy />
    </footer>
  );
}
